const OrderStatuses = Object.freeze({
  Pending: "pending",
  Shipped: "shipped",
  Delivered: "delivered",
  Returned: "returned",
  Canceled: "canceled",
} as const);

export type OrderStatus = (typeof OrderStatuses)[keyof typeof OrderStatuses];

export const OrderStatusLabels = Object.freeze({
  [OrderStatuses.Pending]: "Pending",
  [OrderStatuses.Shipped]: "Shipped",
  [OrderStatuses.Delivered]: "Delivered",
  [OrderStatuses.Returned]: "Returned",
  [OrderStatuses.Canceled]: "Canceled",
});

export default OrderStatuses;
